export const getDisplayOrders = (maxDisplayOrder: number) => {
  return Array.from(Array(maxDisplayOrder)).map((_, i) => { return { value: i + 1, label: `${i + 1}` }; });
};
